import styled from "@emotion/styled";
import { GrBox } from "@jnpmedi/grebob";
import { LayoutContextProvider } from "@newHooks/context/layout/layout.context";
import { Header } from "./common/Header";
import { LeftSideBar } from "./common/LeftSideBar/LeftSideBar";
import { Main } from "./common/Main";
import { NotificationHeader } from "./common/NotificationHeader";
import { PublicHeader } from "./common/PublicHeader";

export function BaseLayout({ children }: { children: React.ReactNode }) {
  return (
    <BaseLayoutSection>
      <LayoutContextProvider>
        <NotificationHeader />
        {children}
      </LayoutContextProvider>
    </BaseLayoutSection>
  );
}

BaseLayout.Main = Main;
BaseLayout.Header = Header;
BaseLayout.PublicHeader = PublicHeader;
BaseLayout.LeftSideBar = LeftSideBar;

const BaseLayoutSection = styled(GrBox)`
  height: 100vh;
`;
